import { render, staticRenderFns } from "./czBasic.vue?vue&type=template&id=7575846c&scoped=true&"
import script from "./czBasic.vue?vue&type=script&lang=js&"
export * from "./czBasic.vue?vue&type=script&lang=js&"
import style0 from "./czBasic.vue?vue&type=style&index=0&id=7575846c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7575846c",
  null
  
)

export default component.exports